// styled
import { IdInner, IdText, TableCellWrapper } from './style';
// type
import type { ICell } from './type';

export interface IIdCell extends ICell {
	username: string;
	full_name: string;
}

const Id = ({ _width, _margin, _padding, username, full_name }: IIdCell) => {
	return (
		<TableCellWrapper
			_width={_width}
			flex="start"
			_margin={_margin}
			_padding={_padding ?? '0 0 0 16px'}
		>
			<IdInner>
				<IdText>
					<div>
						<span>{username}</span>
					</div>
					<div>
						<span>{full_name}</span>
					</div>
				</IdText>
			</IdInner>
		</TableCellWrapper>
	);
};

export default Id;
